import { Component, ChangeDetectionStrategy, Input, EventEmitter, Output, inject } from '@angular/core';
import { BaseResizableComponent } from '@src/app/modules/base';
import { TranslateService } from '@ngx-translate/core';

import { LoyaltyProgramProduct } from '../../../models';
import { LoyaltyProgramPermService } from '../../../services';

@Component({
  selector: 'lp-view-info-block',
  templateUrl: './view-info-block.component.html',
  styleUrls: ['./view-info-block.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ViewInfoBlockComponent extends BaseResizableComponent {
  private readonly translateService = inject(TranslateService);
  private readonly permService = inject(LoyaltyProgramPermService);

  @Input() product?: LoyaltyProgramProduct;
  @Input() productUnionId?: string;
  @Input() isUserOrganisation = false;
  @Input() isUserAssociation = false;
  @Output() getDiscount = new EventEmitter();
  @Output() externalLink: EventEmitter<string> = new EventEmitter<string>();

  get title() {
    if (this.product?.isNew) {
      return this.translateService.instant('components.loyaltyViewInfoBlock.labels.statusNew');
    }

    switch (this.product?.status) {
      case 'archive':
        return this.translateService.instant('components.loyaltyViewInfoBlock.labels.statusArchive');
      case 'review':
        return this.translateService.instant('components.loyaltyViewInfoBlock.labels.statusReview');
      default:
        return;
    }
  }

  get allowedProductCodesExport() {
    return (
      this.product?.terms?.length === 1 &&
      this.product.terms[0].isPermanentCode === false &&
      ((this.permService.allowedProductCodesExport && this.isUserAssociation) ||
        (this.permService.allowedOnlyYourOrganisationProductEditing && this.isUserOrganisation))
    );
  }
}
